import React from 'react';

import Container from 'legacy/common/components/layout/Container';

const EditOrgSkeleton = () => (
  <>
    <div className="animate-pulse h-[60px] -mt-[10px] w-full bg-gray-200" />
    <div className="animate-pulse pt-[40px] pb-20 w-[730px] mx-auto flex flex-col items-center">
      <Container>
        <div className="flex flex-row flex-1">
          <div className="w-[310px]">
            <div
              style={{ aspectRatio: '9 / 16' }}
              className="rounded-lg shadow-xl overflow-hidden bg-gray-200"
            />
          </div>
          <div className="flex-1 flex pl-10 justify-center flex-col">
            <div className="align-center justify-center flex">
              <div className="h-[100px] w-[100px] bg-gray-200 rounded-xl" />
            </div>
            <div className="mt-6 h-[40px] w-full bg-gray-200 rounded-xl" />
            <div className="mt-4 h-[30px] w-full bg-gray-200 rounded-xl" />
            <div className="mt-6 h-[130px] w-full bg-gray-200 rounded-xl" />
          </div>
        </div>
      </Container>
    </div>
  </>
);

export default EditOrgSkeleton;
